import { render, staticRenderFns } from "./OnMapPlace.vue?vue&type=template&id=40ba26b0&"
import script from "./OnMapPlace.vue?vue&type=script&lang=js&"
export * from "./OnMapPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports